<template>
  <!--联系人-->
  <div>
    <div class="goods-head">
      <div class="slider-list">
        <div class="item selected">联系人</div>
      </div>
      <!-- 查询表单  -->
      <div class="goods-head-form">
        <div class="fileds">
          <el-form ref="ruleForm" :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="公司名称">
              <el-input v-model.trim="formInline.companyName" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="联系人">
              <el-input v-model.trim="formInline.relationName" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="客户类型">
              <el-select v-model="formInline.customerType" placeholder="请选择">
                <el-option label="svip" value="1" />
                <el-option label="vip" value="2" />
                <el-option label="普通客户" value="3" />
                <el-option label="老客户" value="4" />
                <el-option label="合作伙伴" value="5" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="buttons">
          <el-button size="small" style="background-color: #BE2316;border-color: #F56C6C;" class="form-item-btn" type="primary"
            @click="searchCriteria(formInline)">
            <i class="el-icon-search" />查询
          </el-button>
          <el-button size="small" style="background-color: #BE2316;border-color: #F56C6C;" class="form-item-btn" type="primary"
            @click="resetForm('ruleForm')">
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <!--表格操作-->
    <section class="operations clearfloat">
      <template>
        <div class="operations-add" @click="addPopClick">
          <i class="iconfont iconjia" />
          新增
        </div>
        <div class="operations-del" @click="batchDel">
          <i class="iconfont iconshanchu" />
          批量删除
        </div>
        <!-- <div class="operations-recommend" @click="recommendPopClick">
          <i class="iconfont iconelite" />
          推荐
        </div> -->
      </template>
    </section>
    <!--表格-->
    <section class="main">
      <!--表格头部-->
      <article class="main-header">
        <ul>
          <li>
            <el-checkbox v-model="allSelection" @change="selection()" />
          </li>
          <li>公司名称</li>
          <li>客户类别</li>
          <li>是否业务客户</li>
          <li>联系人</li>
          <li>性别</li>
          <li>联系电话</li>
          <li>操作</li>
        </ul>
      </article>
      <!--表格内容-->
      <article class="main-body">
        <template v-if="detailsData.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item,itemIndex) in detailsData">
          <div :key="itemIndex" class="body-item">
            <ul>
              <li>
                <el-checkbox v-model="item.selection" @change="change()" />
              </li>
              <li>{{ item.companyName }}</li>
              <li>
                <span v-if="item.customerType==1">svip</span>
                <span v-else-if="item.customerType==2">vip</span>
                <span v-else-if="item.customerType==3">普通客户</span>
                <span v-else-if="item.customerType==4">老客户</span>
                <span v-else-if="item.customerType==5">合作伙伴</span>
                <span v-else>否</span>
              </li>
              <li>
                <span v-if="item.isBusiness==2">是</span>
                <span v-else>否</span>
              </li>
              <li>{{ item.relationName }}</li>
              <li>{{ item.relationSex }}</li>
              <li>{{ item.relationPhone }}</li>
              <li>
                <el-button type="text" @click="popEdit(item)">编辑</el-button>
                <el-divider direction="vertical" />
                <el-button type="text" @click="tableDelete(item.id)">删除</el-button>
                <el-divider direction="vertical" />
                <el-button type="text" @click="addRecordClick(item)">添加记录</el-button>
                <el-button plain size="small" @click="detailsClick(itemIndex)">
                  详情
                  <i :class="{'expand': detailsIndex === itemIndex}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <businessDetails v-if="detailsIndex === itemIndex" class="businessIf" :relation-id="item.id" :details="item" />
          </div>
        </template>
      </article>
      <!--分页-->
      <article class="main-pagination">
        <el-pagination :current-page="pagination.pageNo" :total="pagination.total" :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes" @current-change="changeCurrent" @size-change="changeSize" />
      </article>
    </section>
    <!--新增编辑弹窗-->
    <addEditDialog v-if="dialogShow" :dialog-show="dialogShow" :pop-data="addPopData" :details-data="detailsData"
      :status="dialogStatus" :title="dialogTitle" @EchoClick="getSetList" @closeDialog="closeDialog" />
    <!--添加记录-->
    <el-dialog :visible.sync="addRecordPop" title="添加联系记录" class="see-dialog" width="900px">
      <section class="addRecord-wrap">
        <el-form ref="addRecordForm" :model="addRecordData" :rules="rules" label-position="right" label-width="7rem">
          <el-row align="middle" class="main-item">
            <el-col :span="12" class="address">
              公司名称：
              <span>{{ addRecordData.companyName }}</span>
            </el-col>
            <el-col :span="12" class="address">
              公司地址：
              <span>{{ addRecordData.companyAddress }}</span>
            </el-col>
          </el-row>
          <el-row align="middle" class="main-item">
            <el-col :span="12" class="address">
              联系人：
              <span>{{ addRecordData.relationName }}</span>
            </el-col>
            <el-col :span="12" class="address">
              联系电话：
              <span>{{ addRecordData.relationPhone }}</span>
            </el-col>
          </el-row>
          <el-row align="middle" class="main-item">
            <el-col :span="12" class="address">
              固定电话：
              <span>{{ addRecordData.fixTelphone }}</span>
            </el-col>
            <el-col :span="12" class="address">
              是否业务客户：
              <span v-if="addRecordData.isBusiness==1" style="color: #BE2316">否</span>
              <span v-if="addRecordData.isBusiness==2" style="color: #BE2316">是</span>
            </el-col>
          </el-row>
          <el-row align="middle" class="main-item">
            <el-col :span="24" class="address">
              建立客户时间：
              <span>{{ addRecordData.createDate }}</span>
            </el-col>
          </el-row>
          <div class="addRecord">
            <div class="addRecord-header">
              联系记录：
              <div class="addRecord-add" @click="recordAddedClick()">
                <i class="iconfont iconjia" />
                新增
              </div>
            </div>
            <div class="addRecord-table">
              <!--v-for="(item,itemIndex) in adw"-->
              <el-row v-for="(item,index) in contactRecordData" :key="index" align="middle" class="addRecord-con">
                <el-col v-if="item.ifShow==false" :span="8">{{ item.createDate }}</el-col>
                <el-col v-if="item.ifShow==false" :span="6" :offset="6">
                  <span class="addRecord-con-table-dc" :title="item.relationRecord">{{ item.relationRecord }}</span>
                </el-col>
                <el-col v-if="item.ifShow==false" :span="2">
                  <div class="addRecord-table-modify" @click="modifyOneClick(index)">修改</div>
                </el-col>
                <el-col v-if="item.ifShow==false" :span="2">
                  <div class="addRecord-table-del" @click="delClick(item)">删除</div>
                </el-col>
                <el-form v-if="contactRecordData[index].ifShow" :ref="'contactRecordData'+index" :model="contactRecordData[index]"
                  :rules="rules">
                  <el-col v-if="item.ifShow" :span="8">
                    <el-form-item class="reg-must2" prop="createDate" required>
                      <el-date-picker v-model="contactRecordData[index].createDate" :editable="false" type="datetime"
                        format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"
                        :picker-options="pickerBeforeToday" />
                    </el-form-item>
                  </el-col>
                  <el-col v-if="item.ifShow" :span="6" :offset="6">
                    <el-form-item class="reg-must2" prop="relationRecord" required>
                      <el-input v-model="contactRecordData[index].relationRecord" />
                    </el-form-item>
                  </el-col>
                  <el-col v-if="item.ifShow" :span="4">
                    <div class="addRecord-table-determine" @click="determineOneClick(index,'contactRecordData')">保存</div>
                  </el-col>
                </el-form>
              </el-row>
            </div>
            <el-form ref="addContactRecords" :model="addContactRecords" :rules="rules">
              <el-row v-if="recordTemplate" align="middle" class="addRecord-template">
                <el-col :span="6">
                  <el-form-item prop="createDate" class="reg-must" required>
                    <el-date-picker v-model="addContactRecords.createDate" type="datetime" :editable="false" format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" :picker-options="pickerBeforeToday" />
                  </el-form-item>
                </el-col>
                <el-col :span="8" :offset="2">
                  <el-form-item class="reg-must" prop="relationRecord" required>
                    <el-input v-model="addContactRecords.relationRecord" placeholder="交流内容" />
                    <!--<span v-if="addContactRecords.relationRecord">还可以输入{{ titleMaxLength - addContactRecords.relationRecord.length }}个字</span>-->
                  </el-form-item>
                  <!--公司地址：<span>济南市高新区齐鲁软件园A-2座</span>-->
                </el-col>
                <el-col :span="6" :offset="2">
                  <div class="addRecord-template-btn" @click="recordAddedCunClick('addContactRecords')">保存</div>
                </el-col>
              </el-row>
            </el-form>
            <div class="addRecord-preservation" @click="subRecordClick(addRecordData.id)">提交</div>
          </div>
        </el-form>
      </section>
    </el-dialog>
    <!--推荐联系人-->
    <recommendDialog v-if="recommendShow" :dialog-show="recommendShow" :pop-data="RecommendData" :recommend-id="recommendId"
      @closeDialog="closeRecommendDialog" />
  </div>
</template>

<script type="text/ecmascript-6">
  import * as get from '@/api/personal/customer/contacts/index.js' // 请求接口
  import inputFilter from '@/directives/validation/index.js'
  import businessDetails from '../components/business-contacts'
  import addEditDialog from './components/addEditDialog'
  import recommendDialog from './components/recommendDialog'
  import {
    dateCheck
  } from '@/utils/dateCheck.js'
  import {
    Page
  } from '@/utils/commonDataModel'
  export default {
    components: {
      businessDetails,
      addEditDialog,
      recommendDialog
    },
    directives: {
      inputFilter
    },
    // 混入时间校验
    mixins: [dateCheck],
    data() {
      return {
        // 弹窗状态
        dialogStatus: 'create',
        // 新增编辑弹窗标题
        dialogTitle: '联系人-新增',
        // 详情状态
        detailsIndex: -1,
        // 搜索条件表单
        formInline: {
          companyName: '',
          relationName: '',
          customerType: ''
        },
        // 正则
        rules: {
          companyName: [{
            required: true,
            message: '必填'
          }],
          data: [{
            required: true,
            message: '必填'
          }],
          companyAddress: [{
            required: true,
            message: '必填'
          }],
          // 联系人
          relationName: [{
              required: true,
              message: '必填'
            },
            {
              validator: this.$validate('name')
            }
          ],
          relationSex: [{
            required: true,
            message: '必填'
          }],
          // 手机号
          relationPhone: [{
              required: true,
              message: '必填'
            },
            {
              validator: this.$validate('phone')
            }
          ],
          // 固话
          fixTelphone: [{
            validator: this.$validate('fixedLine')
          }],
          // 时间
          createDate: [{
            required: true,
            message: '必填'
          }],
          // 交流内容
          relationRecord: [{
              required: true,
              message: '必填'
            },
            {
              validator: this.$character(1, 30, 'checkEmpty')
            },
          ]
        },
        // 全选状态
        allSelection: false,
        // 推荐联系人全选
        allSelectionRecommend: false,
        // 联系人表格数据
        detailsData: [
          // { selection: false, companyName: '山东新星集团', customerType: '普通客户', isBusiness: '是', relationName: '孙雅美', relationSex: '女', relationPhone: '15389229003' },
        ],
        // 推荐联系人数据
        RecommendData: [{
          hidden: false,
          selection: false,
          companyName: '',
          companyAddress: '',
          relationName: '',
          relationSex: '',
          relationPhone: ''
        }],
        // 推荐联系人多选id保存（在列表中查询用）
        recommendId: [],
        // 推荐联系人弹窗
        recommendShow: false,
        // 新增业务弹窗状态
        dialogShow: false,
        // 新增数据
        addPopData: {
          companyName: '', // 公司名称
          companyAddress: '', // 公司地址
          relationName: '', // 联系人
          relationSex: '男', // 性别
          relationPhone: '', // 联系电话
          fixTelphone: '', // 固定电话
          remarks: '', // 备注
          relationId: '', // Id
          data: []
        },
        // 新增公司下拉数据
        addPopSelectData: {
          companyName: '',
          companyAddress: ''
        },
        // 添加记录回显数据
        addRecordData: {
          companyName: '', // 公司名称
          companyAddress: '', // 公司地址
          relationName: '', // 联系人
          relationPhone: '', // 联系电话
          fixTelphone: '', // 固定电话
          isBusiness: '', // 是否业务用户
          createDate: '' // 建立客户时间
        },
        // 添加业务弹窗新增一条
        recordTemplate: false,
        // 添加记录-添加联系人
        addContactRecords: {
          createDate: '',
          relationRecord: '',
          ifShow: false
        },
        // 添加联系记录弹窗
        addRecordPop: false,
        // 添加联系记录 暂时添加的数据（发给后台的）
        TemporaryCententData: [],
        // 添加联系-联系记录数据 （接受后台渲染的）
        contactRecordData: [
          // { createDate: '' , ifShow : false}
        ],
        // 表格分页
        pagination: new Page(),
        // 保存和编辑 备注内容、字数
        titleMaxLength: 255
      }
    },
    watch: {
      // 添加联系记录，限制字数
      'addContactRecords.relationRecord'() {
        if (this.addContactRecords.relationRecord.length > this.titleMaxLength) {
          this.addContactRecords.relationRecord = String(
            this.addContactRecords.relationRecord
          ).slice(0, this.titleMaxLength)
        }
      }
    },
    created() {
      // 获取联系人数据
      this.getSetList()
    },
    mounted() {
      document.onkeydown = (e) => {
        // console.log(e)
        if (e.keyCode === 13) {
          this.searchCriteria(this.formInline)
        }
      }
    },
    methods: {
      // 关闭新增修改弹窗
      closeDialog() {
        this.dialogShow = false
        // 清空输入框
        this.addPopData = {
          companyName: '', // 公司名称
          companyAddress: '', // 公司地址
          relationName: '', // 联系人
          relationSex: '男', // 性别
          relationPhone: '', // 联系电话
          fixTelphone: '', // 固定电话
          remarks: '', // 备注
          relationId: '', // Id
          data: []
        }
      },
      // 关闭推荐联系人弹窗
      closeRecommendDialog() {
        this.recommendShow = false
        // 刷新列表
        this.getSetList()
      },
      // 获取列表
      getSetList() {
        // 获取联系人数据
        get
          .getContactsList()
          .then(res => {
            console.log(res)
            this.pagination.total = res.result.total
            this.pagination.pageNo = res.result.pageNo
            this.pagination.pageSize = res.result.pageSize
            const odata = res.result.rows
            this.detailsData = odata.map(ele => {
              ele.selection = false
              return ele
            })
          })
          .catch(error => {
            console.log(error)
          })
      },
      // 条件查询按钮
      searchCriteria(data) {
        console.log(data)
        for (const i in data) {
          data[i] = data[i].replace(/\s+/g, '')
        }
        get
          .getContactsList(data)
          .then(res => {
            this.pagination.total = res.result.total
            this.pagination.pageNo = res.result.pageNo
            this.pagination.pageSize = res.result.pageSize
            this.detailsData = res.result.rows
          })
          .catch(error => {
            console.log(error)
          })
      },
      // 详情
      detailsClick(index) {
        if (this.detailsIndex === index) {
          this.detailsIndex = -1
        } else {
          this.detailsIndex = index
        }
      },
      // 全选
      selection() {
        this.detailsData.forEach(i => {
          if (i.selection !== this.allSelection) {
            i.selection = !i.selection
          }
        })
      },
      // 推荐按钮
      recommendPopClick() {
        const ids = this.detailsData
          .filter(item => item.selection)
          .map(item => item.id)
        const idString = ids.join(',')
        if (ids.length > 0) {
          this.recommendId = idString
          // 打开弹窗
          this.recommendShow = true
        } else {
          this.$message({
            type: 'warning',
            message: '请选择推荐项!'
          })
        }
      },
      // 子项多选
      change() {
        this.allSelection = this.detailsData.every(i => i.selection)
      },
      // 新增联系人按钮
      addPopClick(formName) {
        this.detailsIndex = ''
        this.dialogTitle = '联系人-新增'
        this.dialogStatus = 'create'
        this.dialogShow = true
      },
      // 表格编辑按钮
      popEdit(data) {
        this.dialogTitle = '联系人-编辑'
        this.dialogStatus = 'edit'
        this.addPopData = data
        this.dialogShow = true
      },
      // 表格删除按钮
      tableDelete(id) {
        this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            get
              .deleteContactsList({
                id: id
              })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                get
                  .getContactsList()
                  .then(ress => {
                    const odata = ress.result.rows
                    this.detailsData = odata.map(ele => {
                      ele.selection = false
                      return ele
                    })
                  })
                  .catch(error => {
                    console.log(error)
                  })
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 添加记录按钮
      addRecordClick(data) {
        // console.log(data)
        this.addRecordPop = true
        this.addRecordData = data
        get
          .getContactRecord({
            relationLogId: data.id
          })
          .then(res => {
            console.log('获取到的联系记录', res)
            this.addContactRecords.createDate = '' // 清空输入框
            this.addContactRecords.relationRecord = '' // 清空输入框
            this.addContactRecords.ifShow = '' // 清空输入框
            this.TemporaryCententData = [] // 清空发给后台的数据
            const odata = res.result
            this.contactRecordData = odata.map(ele => {
              ele.ifShow = false
              return ele
            })
          })
          .catch(error => {
            console.log(error)
          })
      },
      // 添加记录-显示输入框
      recordAddedClick() {
        this.recordTemplate = true
      },
      // 添加一条记录 添加到本地页面
      recordAddedCunClick(formName) {
        // 正则匹配

        this.$refs[formName].validate(valid => {
          if (valid) {
            this.recordTemplate = false
            const list = JSON.parse(JSON.stringify(this.addContactRecords))
            this.contactRecordData.push(list)
            this.TemporaryCententData.push(list)
            this.addContactRecords.createDate = ''
            this.addContactRecords.relationRecord = ''
          } else {
            // console.log('error submit!!')
            return false
          }
        })
      },
      // 添加记录-修改（编辑）
      modifyOneClick(index) {
        this.$set(this.contactRecordData[index], 'ifShow', true)
        this.$forceUpdate()
      },
      // 删除记录
      delClick(item) {
        console.log(679, item)
        this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            if (!item.id) {
              this.$message({
                type: 'warning',
                message: '请先提交，在执行此操作!'
              })
              return false
            }
            get
              .delRecorde({
                id: item.id
              })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                // console.log(data)
                this.addRecordPop = true
                get
                  .getContactRecord({
                    relationLogId: this.addRecordData.id
                  })
                  .then(res => {
                    console.log('获取到的联系记录', res)
                    this.addContactRecords.createDate = '' // 清空输入框
                    this.addContactRecords.relationRecord = '' // 清空输入框
                    this.addContactRecords.ifShow = '' // 清空输入框
                    this.TemporaryCententData = [] // 清空发给后台的数据
                    const odata = res.result
                    this.contactRecordData = odata.map(ele => {
                      ele.ifShow = false
                      return ele
                    })
                  })

                  .catch(error => {
                    console.log(error)
                  })
                  .catch(error => {
                    console.log(error)
                  })
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 添加记录-修改（保存按钮）
      determineOneClick(index, formName) {
        const oid = formName + index
        // 正则匹配
        this.$refs[oid][0].validate(valid => {
          if (valid) {
            this.$set(this.contactRecordData[index], 'ifShow', false)
            this.$forceUpdate()
            get
              .determineRecords({
                relationLogId: this.addRecordData.relationLogId,
                createDate: this.contactRecordData[index].createDate,
                relationRecord: this.contactRecordData[index].relationRecord,
                id: this.contactRecordData[index].id
              })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                })
                this.addContactRecords.createDate = ''
                this.addContactRecords.relationRecord = ''
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            return false
          }
        })
      },
      // 添加记录-提交按钮
      subRecordClick(id) {
        const cententData = {}
        cententData.relationLogId = id
        cententData.data = JSON.stringify(this.TemporaryCententData)
        // console.log('提交到后台的数据', cententData)
        console.log(cententData)
        if (this.TemporaryCententData.length > 0) {
          // const cententJson = String(cententData)
          get
            .addRecordsSub(cententData)
            .then(res => {
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
              // 保存后清空并关闭弹窗
              this.addRecordPop = false
              this.contactRecordData = res.result.cententData.data
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          this.$message({
            type: 'warning',
            message: '没有新增记录'
          })
        }
      },
      // 重置表单
      resetForm(ref) {
        this.formInline.companyName = ''
        this.formInline.relationName = ''
        this.formInline.customerType = ''
        this.detailsIndex = -1
        this.getSetList()
        // this.$refs[ref].resetFields()
      },
      // 批量删除
      batchDel() {
        const ids = this.detailsData
          .filter(item => item.selection)
          .map(item => item.id)
        // 如果为选中或者id数量为零，提示用户选择删除的数据
        if (ids == '' || ids.length < 0) {
          this.$message({
            type: 'warning',
            message: '请选择删除的数据!'
          })
          return
        }
        this.$confirm('此操作将删除选中数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            const ids = this.detailsData
              .filter(item => item.selection)
              .map(item => item.id)
            const idString = ids.join(',')
            if (ids.length > 0) {
              get
                .deleteBatchContactsList({
                  id: idString
                })
                .then(res => {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  // 获取联系人数据
                  this.getSetList()
                  // 取消全选
                  this.allSelection = false
                })
                .catch(error => {
                  console.log(error)
                })
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 分页-第几页
      changeCurrent(current) {
        this.pagination.pageNo = current
        get
          .getContactsList(this.pagination)
          .then(res => {
            this.pagination.total = res.result.total
            this.pagination.pageNo = res.result.pageNo
            this.pagination.pageSize = res.result.pageSize
            const odata = res.result.rows
            this.detailsData = odata.map(ele => {
              ele.selection = false
              return ele
            })
          })
          .catch(error => {
            console.log(error)
          })
      },
      // 分页-每页多少条
      changeSize(size) {
        this.pagination.pageSize = size
        get
          .getContactsList(this.pagination)
          .then(res => {
            this.pagination.total = res.result.total
            this.pagination.pageNo = res.result.pageNo
            this.pagination.pageSize = res.result.pageSize
            const odata = res.result.rows
            this.detailsData = odata.map(ele => {
              ele.selection = false
              return ele
            })
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>
<style scoped lang='scss'>
  @import "./index.scss";

  .reg-must,
  .reg-must2 {
    position: relative;
  }

  .reg-must:before {
    content: "*";
    position: absolute;
    color: red;
    left: -13px;
    top: 16px;
  }

  .reg-must2:before {
    content: "*";
    position: absolute;
    color: red;
    left: -13px;
    top: -7px;
  }
</style>
